import { Injectable } from '@angular/core';
import { Location } from '@angular/common'; 
import { Route } from '@angular/router';

import { AppConfigSettings, BrowserStorageService } from '@arc/arc-shared-frontend';
import { TenantService } from './tenant.service';

@Injectable({
  providedIn: 'root'
})
export class RoutingService {

  constructor(
    private browserStorageService: BrowserStorageService,
    private appConfigSettings: AppConfigSettings,
    private location: Location,
    private tenantService: TenantService
  ) { }

  public get collectionsWorkspaceV2URL() {
    return this.appConfigSettings.getconfig('CollectionsWorkspaceV2URL');
  }

  public get collectionsSettingsURL() {
    return this.appConfigSettings.getconfig('ICCollectionsSettingsURL');
  }

  public get currentRoute(): string {
    return this.location.path().split('/')[1];
  }

  // save the route to default to on next login
  persistRoute = (route: Route|string|undefined = undefined): void =>
    (typeof route === 'string')? 
      this.browserStorageService.setItem(`latest_context`, route)
      : this.browserStorageService.setItem(`latest_context`, route?.path ?? this.currentRoute);

  // retrieve route
  retrieveRoute = (): string => {
    let lastApplication = this.browserStorageService.getItem(`latest_context`);

    switch (lastApplication) {
      case 'collections': 
        if (this.tenantService.hasApplication('icontroller-collections-app')) {
          lastApplication = this.collectionsWorkspaceV2URL;
        }
        break;
      default:
        break;
    }
    return lastApplication;
  }
}
